<template>
  <!-- Register Dialog -->
  <v-dialog
    v-model="group_time_dialog"
    :width="width"
    content-class="card pa-0 register-dialog "
    v-if="step < 4 && group_time_dialog"
  >
    <v-btn
      icon
      dark
      variant="text"
      class="dialog-close-btn"
      @click="$emit('close-dialog')"
    >
      <v-icon>mdi-close</v-icon>
    </v-btn>

    <component
      @close-dialog="$emit('close-dialog')"
      :is="currentStepComponent"
      :is_mobile="is_mobile"
      :registeractivity="registeractivity"
      :enroll="enroll"
      :activity="activity"
      :page="page"
      :stepLabel="stepLabel"
      :changing="true"
      :locationIndex="locationIndex"
      :locationActive="locationActive"
      :multiple="false"
      :firstStep="firstStep"
      :locale="$i18n.locale"
      @next-step="nextStep"
      @prev-step="prevStep"
      @update-data="updateData"
      @register="register"
    />
  </v-dialog>

  <!-- Confirmation Dialog -->
  <relocation-confirm-dialog
    v-else-if="confirm_dialog"
    v-model="confirm_dialog"
    :new_date="toAmsterdamMidnight(registeractivity.date.date).getTime() / 1000"
    :new_start="registeractivity.date.slot.start"
    :new_end="registeractivity.date.slot.end"
    @close-dialog="$emit('close-dialog'), (confirm_dialog = false)"
    :image="activity.image"
  />
</template>

<script>
import StepOne from "../registercomponents/StepOne.vue";
import StepThreeGroup from "../registercomponents/StepThreeGroup.vue";
import StepFour from "../registercomponents/StepFour.vue";
import RelocationConfirmDialog from "../relocation_confirm_dialog.vue";
import isMobile from "@/mixins/isMobile";
import { toAmsterdamMidnight } from "@/util/DateUtil";

export default {
  mixins: [isMobile],
  components: {
    StepOne,
    StepThreeGroup,
    StepFour,
    RelocationConfirmDialog,
  },
  props: {
    activity: Object,
    page: Object,
    enroll: Object, // Keeps enroll functionality for group
  },
  data() {
    return {
      group_time_dialog: true,
      confirm_dialog: false,
      step: 1,
      registeractivity: {
        location: this.enroll.location,
        specialist: this.enroll.activity_specialist,
        enroll_id: this.enroll.enroll_id,
        date: {
          date: null,
          slot: {},
        },
        reminder: true,
      },
    };
  },
  computed: {
    firstStep() {
      return this.buildComponents()[0] == this.buildComponents()[this.step - 1];
    },
    width() {
      return this.is_mobile ? "calc(100% - 32px)" : "768px";
    },

    locationActive() {
      const components = this.buildComponents();

      if (components.includes(StepOne)) {
        return true;
      } else {
        return false;
      }
    },
    currentStepComponent() {
      const components = this.buildComponents();
      return components[this.step - 1];
    },
    stepCount() {
      const components = this.buildComponents();
      return components.length >= this.step;
    },
    stepLabel() {
      const components = this.buildComponents();
      const totalSteps = components.length;
      return this.$i18n.locale === "nl"
        ? `Stap ${this.step}/${totalSteps}`
        : `Step ${this.step}/${totalSteps}`;
    },
    locationIndex() {
      return this.activity.locations.findIndex(
        (loc) => loc.id === this.registeractivity.location
      );
    },
  },
  methods: {
    // Uit @/util/DateUtil, zodat de template hem kan aanroepen: de gekozen dag
    // is een lokale middernacht, de bevestiging leest een Amsterdamse epoch.
    toAmsterdamMidnight,
    buildComponents() {
      const components = [];

      const validLocations = this.activity.locations.filter((location) =>
        location.specialists.some((specialist) =>
          specialist.dates.some((date) =>
            date.slots.some((slot) => slot.spots > 0)
          )
        )
      );

      if (validLocations.length === 1) {
        this.registeractivity.location = validLocations[0].id;
        // Skip StepOne
      } else {
        components.push(StepOne);
      }

      components.push(StepThreeGroup, StepFour);

      return components;
    },
    nextStep() {
      this.step += 1;
    },
    prevStep() {
      this.step -= 1;
    },
    updateData(data) {
      Object.assign(this.registeractivity, data);
    },
    register() {
      this.registeractivity.title = this.activity.content.nl.banner.title;
      if (!this.sent) {
        this.registeractivity.enroll_id = this.enroll.enroll_id;
        this.sent = true;
        this.$emit("update-enroll", this.registeractivity);
        this.confirm_dialog = true;
        this.step = 4;
      }
    },
  },
};
</script>
